var _ref2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFilter = function SvgFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 26,
      viewBox: "0 0 24 26",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.8772 16.8027L12.9032 18.3357V13.7827C12.9032 13.6167 12.9452 13.4537 13.0232 13.3077L17.3232 5.3457H6.64323L10.7652 13.3237C10.8392 13.4657 10.8772 13.6237 10.8772 13.7827V16.8027ZM13.9032 21.3457C13.6902 21.3457 13.4772 21.2777 13.3002 21.1427L9.27423 18.0977C9.02423 17.9087 8.87723 17.6137 8.87723 17.3007V14.0267L4.11223 4.8047C3.95123 4.4947 3.96423 4.1237 4.14623 3.8257C4.32723 3.5277 4.65123 3.3457 5.00023 3.3457H19.0002C19.3522 3.3457 19.6782 3.5307 19.8592 3.8337C20.0392 4.1357 20.0472 4.5107 19.8802 4.8207L14.9032 14.0357V20.3457C14.9032 20.7247 14.6892 21.0717 14.3492 21.2407C14.2082 21.3107 14.0552 21.3457 13.9032 21.3457Z",
      fill: "#041F47"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgFilter, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/filter.97a01ad1.svg";
export { ForwardRef as ReactComponent };